import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchStitchingReg } from '../../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchReg } from '../../Selectors/StitchSelector/StitchingSelectors';

const StitchingInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        stMemo: '',
        piMemo: '',
        empNm: '',
        itemNm: '',
        brandNm: '',
        partyNm: '',
        departNm: '',
        totqty: '',
        instruction: '',
        totmat: ''
    });
    const [material, setMaterial] = useState([]);
    const [itemSizes, setItemSizes] = useState([]);
    const { Id } = useParams();
    const dispatch = useDispatch();
    const stitchlist = useSelector(selectStitchReg);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchStitchingReg(Id))
    }, [Id, dispatch]);
    useEffect(() => {
        if (stitchlist?.data) {
            const item = stitchlist?.data;
            setFormData(prev => ({
                ...prev,
                dt: item.dt,
                stMemo: item.stMemo,
                piMemo: item.piMemo,
                empNm: item.empNm,
                itemNm: item.itemNm,
                brandNm: item.brandNm,
                partyNm: item.partyNm,
                departNm: item.departNm,
                totqty: item.qty,
                instruction: item.instruction
            }));
        }
        if (stitchlist?.Info2?.length > 0) {
            const value = stitchlist?.Info2;
            setMaterial(value);
            const sumtot = value?.reduce((acc, val) => acc + parseFloat(val.issqty), 0);
            setFormData(prev => ({
                ...prev,
                totmat: sumtot
            }));
        }
        if (stitchlist?.Info?.length > 0) {
            const value2 = stitchlist?.Info?.length > 0 ? {
                size: stitchlist.Info.map(val => val.size),
                piqty: stitchlist.Info.map(val => parseFloat(val.piqty)),
                issqty: stitchlist.Info.map(val => parseFloat(val.issqty)),
                balqty: stitchlist.Info.map(val => parseFloat(val.balqty)),
            } : [];
            setItemSizes(value2);
        }
    }, [stitchlist]);


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };



    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Job Give Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Party</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Stitch Memo</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.stMemo}</td>

                                    <td style={{ width: '200px' }}>PI Ref. No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.piMemo}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Department</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.departNm}</td>
                                    <td style={{ width: '200px' }}>Brand</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.brandNm}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totqty}</td>
                                </tr>

                            </tbody>
                        </table>

                        {formData.instruction !== "0" &&
                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                                <tbody>
                                    <tr>

                                        <td style={{ width: '200px' }}>Instruction</td>
                                        <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>

                                    </tr>
                                </tbody>
                            </table>}
                        {itemSizes?.size?.length > 0 &&
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                            {itemSizes?.size ? itemSizes?.size?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>


                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>PI Qty.</TableCell>
                                            {itemSizes?.piqty ? itemSizes?.piqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>

                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                            {itemSizes?.issqty ? itemSizes?.issqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </TableContainer>}

                        {material.length > 0 &&
                            <div style={{ margin: '1% 5%', fontSize: '14px' }}>
                                <h3>Material Details </h3>

                                <table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Material Work</th>
                                            <th>Qty.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {material.map((mat, matIndex) => (
                                            <>
                                                <tr key={matIndex}>
                                                    <td>
                                                        {matIndex + 1}
                                                    </td>
                                                    <td>
                                                        {mat.materialNm}
                                                    </td>
                                                    <td>
                                                        {mat.issqty}
                                                    </td>

                                                </tr>
                                            </>
                                        ))}
                                        <tr>
                                            <td> </td>
                                            <td>
                                                <span className="tot-lump">Total Qty</span>
                                            </td>
                                            <td>
                                                <span className="tot-lump">{formData.totmat}</span>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>

                            </div>}

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default StitchingInfo;
